/** Booster frequency */
export var BoosterFrequency;
(function (BoosterFrequency) {
    BoosterFrequency["Infinite"] = "INFINITE";
    BoosterFrequency["Once"] = "ONCE";
    BoosterFrequency["Twice"] = "TWICE";
})(BoosterFrequency || (BoosterFrequency = {}));
/** Access restriction status */
export var FdrAccountAccessRestrictionStatus;
(function (FdrAccountAccessRestrictionStatus) {
    FdrAccountAccessRestrictionStatus["Expired"] = "EXPIRED";
    FdrAccountAccessRestrictionStatus["UnknownStatus"] = "UNKNOWN_STATUS";
    /** @deprecated No longer supported */
    FdrAccountAccessRestrictionStatus["VflyStatus"] = "VFLY_STATUS";
})(FdrAccountAccessRestrictionStatus || (FdrAccountAccessRestrictionStatus = {}));
/** Available payment actions. */
export var FdrAccountAvailablePaymentAction;
(function (FdrAccountAvailablePaymentAction) {
    /** nothing to pay, Do not show initiate payment/change payment method area */
    FdrAccountAvailablePaymentAction["PaymentActionChangePayment"] = "PAYMENT_ACTION_CHANGE_PAYMENT";
    /** Display change payment method information */
    FdrAccountAvailablePaymentAction["PaymentActionInitPayment"] = "PAYMENT_ACTION_INIT_PAYMENT";
    /** Display initiate payment information */
    FdrAccountAvailablePaymentAction["PaymentActionNotAvailable"] = "PAYMENT_ACTION_NOT_AVAILABLE";
    /** Do not allow initiate payment/change payment for "RIK" bookings */
    FdrAccountAvailablePaymentAction["PaymentActionOffline"] = "PAYMENT_ACTION_OFFLINE";
})(FdrAccountAvailablePaymentAction || (FdrAccountAvailablePaymentAction = {}));
/** Status of booking. */
export var FdrAccountBookingStatus;
(function (FdrAccountBookingStatus) {
    FdrAccountBookingStatus["Booked"] = "BOOKED";
    FdrAccountBookingStatus["Cancelled"] = "CANCELLED";
    FdrAccountBookingStatus["Failed"] = "FAILED";
    FdrAccountBookingStatus["Pending"] = "PENDING";
    FdrAccountBookingStatus["Travelled"] = "TRAVELLED";
    FdrAccountBookingStatus["Unknown"] = "UNKNOWN";
})(FdrAccountBookingStatus || (FdrAccountBookingStatus = {}));
/** Flight direction */
export var FdrAccountFlightDirection;
(function (FdrAccountFlightDirection) {
    FdrAccountFlightDirection["Inbound"] = "INBOUND";
    FdrAccountFlightDirection["Outbound"] = "OUTBOUND";
})(FdrAccountFlightDirection || (FdrAccountFlightDirection = {}));
/** Payment status paid or not. */
export var FdrAccountPaymentStatus;
(function (FdrAccountPaymentStatus) {
    FdrAccountPaymentStatus["Open"] = "OPEN";
    FdrAccountPaymentStatus["Paid"] = "PAID";
})(FdrAccountPaymentStatus || (FdrAccountPaymentStatus = {}));
/**
 * Product status.
 * Where are match more product statuses, but now we are need only REQUESTED.
 */
export var FdrAccountProductStatus;
(function (FdrAccountProductStatus) {
    FdrAccountProductStatus["Requested"] = "REQUESTED";
    FdrAccountProductStatus["Unknown"] = "UNKNOWN";
})(FdrAccountProductStatus || (FdrAccountProductStatus = {}));
/** Travel type */
export var FdrAccountTravelType;
(function (FdrAccountTravelType) {
    FdrAccountTravelType["Flight"] = "FLIGHT";
    FdrAccountTravelType["Hotel"] = "HOTEL";
    FdrAccountTravelType["Package"] = "PACKAGE";
})(FdrAccountTravelType || (FdrAccountTravelType = {}));
/** Agency brand */
export var FdrAgencyBrand;
(function (FdrAgencyBrand) {
    FdrAgencyBrand["GlobusReisen"] = "GLOBUS_REISEN";
    FdrAgencyBrand["Hotelplan"] = "HOTELPLAN";
    FdrAgencyBrand["Sv"] = "SV";
    FdrAgencyBrand["Tpt"] = "TPT";
    FdrAgencyBrand["Travelhouse"] = "TRAVELHOUSE";
    FdrAgencyBrand["Ungrouped"] = "UNGROUPED";
    FdrAgencyBrand["Unspecified"] = "UNSPECIFIED";
})(FdrAgencyBrand || (FdrAgencyBrand = {}));
/** Type of location, result of autosuggestion */
export var FdrAgencyGeoLocationType;
(function (FdrAgencyGeoLocationType) {
    FdrAgencyGeoLocationType["City"] = "CITY";
    FdrAgencyGeoLocationType["Region"] = "REGION";
})(FdrAgencyGeoLocationType || (FdrAgencyGeoLocationType = {}));
/** Open agency status */
export var FdrAgencyOpenStatus;
(function (FdrAgencyOpenStatus) {
    FdrAgencyOpenStatus["Close"] = "CLOSE";
    FdrAgencyOpenStatus["Open"] = "OPEN";
    FdrAgencyOpenStatus["Unspecified"] = "UNSPECIFIED";
})(FdrAgencyOpenStatus || (FdrAgencyOpenStatus = {}));
/** Enum defined selection type all agencies / or only defined */
export var FdrAgencyRecommenderSelectionType;
(function (FdrAgencyRecommenderSelectionType) {
    /** Recommend all agencies */
    FdrAgencyRecommenderSelectionType["All"] = "ALL";
    /** Recommend only manual defined agencies */
    FdrAgencyRecommenderSelectionType["Selected"] = "SELECTED";
})(FdrAgencyRecommenderSelectionType || (FdrAgencyRecommenderSelectionType = {}));
/** Enum defined agencies order on the recomendation component */
export var FdrAgencyRecommenderSortingType;
(function (FdrAgencyRecommenderSortingType) {
    /** Order defined in cms */
    FdrAgencyRecommenderSortingType["AsDefined"] = "AS_DEFINED";
    /** Order according to response from agencies subgraph */
    FdrAgencyRecommenderSortingType["Automatic"] = "AUTOMATIC";
})(FdrAgencyRecommenderSortingType || (FdrAgencyRecommenderSortingType = {}));
/** Agency search mode */
export var FdrAgencySearchMode;
(function (FdrAgencySearchMode) {
    FdrAgencySearchMode["AgencySearchModeAutosuggest"] = "AGENCY_SEARCH_MODE_AUTOSUGGEST";
    FdrAgencySearchMode["AgencySearchModePartialWord"] = "AGENCY_SEARCH_MODE_PARTIAL_WORD";
    FdrAgencySearchMode["AgencySearchModePhrase"] = "AGENCY_SEARCH_MODE_PHRASE";
})(FdrAgencySearchMode || (FdrAgencySearchMode = {}));
export var FdrAlternativeRoomMealType;
(function (FdrAlternativeRoomMealType) {
    FdrAlternativeRoomMealType["AlternativeMeal"] = "ALTERNATIVE_MEAL";
    FdrAlternativeRoomMealType["AlternativeRoom"] = "ALTERNATIVE_ROOM";
    FdrAlternativeRoomMealType["AlternativeRoomAndMeal"] = "ALTERNATIVE_ROOM_AND_MEAL";
})(FdrAlternativeRoomMealType || (FdrAlternativeRoomMealType = {}));
export var FdrAttachmentTravelDocumentType;
(function (FdrAttachmentTravelDocumentType) {
    FdrAttachmentTravelDocumentType["Invoice"] = "INVOICE";
    FdrAttachmentTravelDocumentType["TravelInformation"] = "TRAVEL_INFORMATION";
    FdrAttachmentTravelDocumentType["Voucher"] = "VOUCHER";
})(FdrAttachmentTravelDocumentType || (FdrAttachmentTravelDocumentType = {}));
export var FdrAuthMethodType;
(function (FdrAuthMethodType) {
    FdrAuthMethodType["AgentId"] = "AGENT_ID";
    FdrAuthMethodType["EMail"] = "E_MAIL";
    FdrAuthMethodType["Facebook"] = "FACEBOOK";
    FdrAuthMethodType["Google"] = "GOOGLE";
    FdrAuthMethodType["Phone"] = "PHONE";
})(FdrAuthMethodType || (FdrAuthMethodType = {}));
export var FdrBookingCancellationCode;
(function (FdrBookingCancellationCode) {
    FdrBookingCancellationCode["BookingCancellationCodeError"] = "BOOKING_CANCELLATION_CODE_ERROR";
    FdrBookingCancellationCode["BookingCancellationCodeErrorNotAuthorized"] = "BOOKING_CANCELLATION_CODE_ERROR_NOT_AUTHORIZED";
    FdrBookingCancellationCode["BookingCancellationCodeOk"] = "BOOKING_CANCELLATION_CODE_OK";
})(FdrBookingCancellationCode || (FdrBookingCancellationCode = {}));
export var FdrBookingCancellationType;
(function (FdrBookingCancellationType) {
    FdrBookingCancellationType["CancellationConfirmation"] = "CANCELLATION_CONFIRMATION";
    FdrBookingCancellationType["CancellationFinalization"] = "CANCELLATION_FINALIZATION";
})(FdrBookingCancellationType || (FdrBookingCancellationType = {}));
/** Object types available for bookmarks */
export var FdrBookmarkObjectType;
(function (FdrBookmarkObjectType) {
    FdrBookmarkObjectType["Geo"] = "GEO";
    FdrBookmarkObjectType["Product"] = "PRODUCT";
    FdrBookmarkObjectType["Theme"] = "THEME";
})(FdrBookmarkObjectType || (FdrBookmarkObjectType = {}));
/** Catalog type */
export var FdrCatalogType;
(function (FdrCatalogType) {
    FdrCatalogType["Catalogue"] = "CATALOGUE";
    FdrCatalogType["Flyer"] = "FLYER";
})(FdrCatalogType || (FdrCatalogType = {}));
/** Checkout status enum. */
export var FdrCheckoutStatus;
(function (FdrCheckoutStatus) {
    /** Offer flight changed status for checkout. */
    FdrCheckoutStatus["FlightChanged"] = "FLIGHT_CHANGED";
    /** Offer flight and price changed status for checkout. */
    FdrCheckoutStatus["PriceAndFlightChanged"] = "PRICE_AND_FLIGHT_CHANGED";
    /** Offer price changed status for checkout. */
    FdrCheckoutStatus["PriceChanged"] = "PRICE_CHANGED";
    /** Success status for checkout. */
    FdrCheckoutStatus["Success"] = "SUCCESS";
    /** Unavailable status for checkout. */
    FdrCheckoutStatus["Unavailable"] = "UNAVAILABLE";
})(FdrCheckoutStatus || (FdrCheckoutStatus = {}));
export var FdrEmailAdvertisingStatus;
(function (FdrEmailAdvertisingStatus) {
    FdrEmailAdvertisingStatus["Error"] = "ERROR";
    FdrEmailAdvertisingStatus["Success"] = "SUCCESS";
})(FdrEmailAdvertisingStatus || (FdrEmailAdvertisingStatus = {}));
/** Flight class enum. */
export var FdrFlightClass;
(function (FdrFlightClass) {
    /** Business flight class. */
    FdrFlightClass["Business"] = "BUSINESS";
    /** Economy flight class. */
    FdrFlightClass["Economy"] = "ECONOMY";
    /** First flight class. */
    FdrFlightClass["First"] = "FIRST";
    /** Premium economy flight class. */
    FdrFlightClass["PremiumEconomy"] = "PREMIUM_ECONOMY";
})(FdrFlightClass || (FdrFlightClass = {}));
/** Flight search sorting type. */
export var FdrFlightSorting;
(function (FdrFlightSorting) {
    /** Sort offers by flight departure time. */
    FdrFlightSorting["FlightDepartureTime"] = "FLIGHT_DEPARTURE_TIME";
    /** Sort offers by flight duration. */
    FdrFlightSorting["FlightDuration"] = "FLIGHT_DURATION";
    /** Sort by flight offer price. */
    FdrFlightSorting["FlightOfferPrice"] = "FLIGHT_OFFER_PRICE";
})(FdrFlightSorting || (FdrFlightSorting = {}));
/** Flight type enum. */
export var FdrFlightType;
(function (FdrFlightType) {
    /** One way flight. */
    FdrFlightType["OneWay"] = "ONE_WAY";
    /** Several one way flights. */
    FdrFlightType["OpenJaw"] = "OPEN_JAW";
    /** Round trip flight. */
    FdrFlightType["Return"] = "RETURN";
})(FdrFlightType || (FdrFlightType = {}));
export var FdrGeoChildrenSorting;
(function (FdrGeoChildrenSorting) {
    FdrGeoChildrenSorting["Name"] = "NAME";
})(FdrGeoChildrenSorting || (FdrGeoChildrenSorting = {}));
/** Geo object levels enum. */
export var FdrGeoLevel;
(function (FdrGeoLevel) {
    /** Continent level. Parent for country groups and countries. Uppermost. */
    FdrGeoLevel["Continent"] = "CONTINENT";
    /** Country level. Parent for regions and destinations. */
    FdrGeoLevel["Country"] = "COUNTRY";
    /** Country group level. Parent for countries. */
    FdrGeoLevel["CountryGroup"] = "COUNTRY_GROUP";
    /** Destination level. Parent for resorts. */
    FdrGeoLevel["Destination"] = "DESTINATION";
    /** Region level. Parent for destinations. */
    FdrGeoLevel["Region"] = "REGION";
    /** Resort level. Lowermost. */
    FdrGeoLevel["Resort"] = "RESORT";
})(FdrGeoLevel || (FdrGeoLevel = {}));
/** Specifies what geo objects should be shown in geo recommender. */
export var FdrGeoRecommenderType;
(function (FdrGeoRecommenderType) {
    /** Children of defined objects will be shown. */
    FdrGeoRecommenderType["ChildrenObjects"] = "CHILDREN_OBJECTS";
    /** Defined geo objects will be shown. */
    FdrGeoRecommenderType["DefinedObjects"] = "DEFINED_OBJECTS";
})(FdrGeoRecommenderType || (FdrGeoRecommenderType = {}));
/** Defines 'shape' of geo search result tree. See documentation for each preset. */
export var FdrGeoSearchResultPreset;
(function (FdrGeoSearchResultPreset) {
    /**
     * For each geo object from search criteria (or for each continent if no search criteria), goes
     * down the geo tree and flattens geo levels with one child until more then 1 geo child encountered,
     * or until DESTINATION level reached. Resulting tree depth is always exactly 2. Originally used
     * for HP SRL page.
     *
     * Example:
     * HUB response:
     * Continent_1
     *     Country_1
     *         Destination_1
     *             Resort_1
     *             Resort_2
     *
     * Resulting geo tree:
     * Destination_1
     *     Resort_1
     *     Resort_2
     */
    FdrGeoSearchResultPreset["FlattenLevelsWithOneChild"] = "FLATTEN_LEVELS_WITH_ONE_CHILD";
    /**
     * Can be used to return next geo level of a geo being searched. If next geo level contains
     * one geo object with the same name, it is flattened to lower level. If no geo objects specified
     * in search criteria, CONTINENT level is returned. If search criteria geo object is resort,
     * same RESORT level is returned. If search criteria contains multiple geo objects with different
     * geo levels, next level of each object is extracted into flat list. Resulting tree depth is always 1.
     * Originally used for HP Geo Overview page.
     *
     * Example 1 (searched object is country)
     * HUB response:
     * Continent                               (Continent)
     *     Singapore                           (Country)
     *         Singapore                       (Destination)
     *             Singapore & Sentosa Island  (Resort)
     *
     * Resulting geo tree (next level for country is destination, but it has same name so it's flattened):
     * Singapore & Sentosa Island              (Resort)
     *
     * Example 2 (no geo objects specified in search criteria):
     * HUB response:
     * Continent_1
     *     Country_1
     *         Destination_1
     *             Resort_1
     *             Resort_2
     * Continent_2
     *     Country_2
     *         Destination_2
     *             Resort_3
     *             Resort_4
     *
     * Resulting geo tree:
     * Continent_1
     * Continent_2
     *
     * Example 3 (search criteria has one resort)
     * HUB response:
     * Continent_1
     *     Country_1
     *         Destination_1
     *             Resort_1
     *
     * Resulting geo tree:
     * Resort_1
     *
     * Example 4 (search criteria has a country, destination and resort):
     * Continent_1
     *     Country_1               (searched country)
     *         Destination_1
     *             Resort_1
     *             Resort_2
     * Continent_2
     *     Country_2
     *         Destination_2   `   (searched destination)
     *             Resort_3
     *             Resort_4
     * Continent_3
     *     Country_3
     *         Destination_3
     *             Resort_5        (searched resort)
     *
     * Resulting geo tree:
     * Destination_1
     * Resort_3
     * Resort_4
     * Resort_5
     */
    FdrGeoSearchResultPreset["NextLevelFlattenLevelsWithSameName"] = "NEXT_LEVEL_FLATTEN_LEVELS_WITH_SAME_NAME";
    /**
     * This preset is used to fetch sub geo filters on SRL page. Resulting geo tree is always one level
     * deep. No continents and country groups is shown. Result always sorted alphabetically.
     */
    FdrGeoSearchResultPreset["SubGeoFilters"] = "SUB_GEO_FILTERS";
})(FdrGeoSearchResultPreset || (FdrGeoSearchResultPreset = {}));
export var FdrGroupSorting;
(function (FdrGroupSorting) {
    /** Sort geo objects tree alphabetically. Sorting applied separately to each geo children. */
    FdrGroupSorting["GroupAlphabetic"] = "GROUP_ALPHABETIC";
    /** Sort geo objects tree by offer's flight duration. */
    FdrGroupSorting["GroupFlightDuration"] = "GROUP_FLIGHT_DURATION";
    /** Sort geo objects tree by "top" geo feature. */
    FdrGroupSorting["GroupTopDestination"] = "GROUP_TOP_DESTINATION";
    /** Sort geo objects by price. */
    FdrGroupSorting["Price"] = "PRICE";
})(FdrGroupSorting || (FdrGroupSorting = {}));
/** Component type */
export var FdrHealthComponentType;
(function (FdrHealthComponentType) {
    FdrHealthComponentType["Service"] = "SERVICE";
})(FdrHealthComponentType || (FdrHealthComponentType = {}));
/** Health status */
export var FdrHealthStatus;
(function (FdrHealthStatus) {
    FdrHealthStatus["Down"] = "DOWN";
    FdrHealthStatus["Up"] = "UP";
})(FdrHealthStatus || (FdrHealthStatus = {}));
/** Image resize mode. Affects how image will be cropped to requested size. */
export var FdrImageResizeMode;
(function (FdrImageResizeMode) {
    FdrImageResizeMode["Auto"] = "AUTO";
    FdrImageResizeMode["Fill"] = "FILL";
    FdrImageResizeMode["FillDown"] = "FILL_DOWN";
    FdrImageResizeMode["Fit"] = "FIT";
    FdrImageResizeMode["Force"] = "FORCE";
})(FdrImageResizeMode || (FdrImageResizeMode = {}));
/** Available languages enumeration. */
export var FdrLanguage;
(function (FdrLanguage) {
    FdrLanguage["De"] = "DE";
    FdrLanguage["En"] = "EN";
    FdrLanguage["Fr"] = "FR";
})(FdrLanguage || (FdrLanguage = {}));
/** Link open method. */
export var FdrLinkOpenMethod;
(function (FdrLinkOpenMethod) {
    /** Open link in new tab. */
    FdrLinkOpenMethod["NewTab"] = "NEW_TAB";
    /** Open link in new window. */
    FdrLinkOpenMethod["NewWindow"] = "NEW_WINDOW";
    /** Open link in overlay. */
    FdrLinkOpenMethod["Overlay"] = "OVERLAY";
    /** Open link in this tab. */
    FdrLinkOpenMethod["ThisTab"] = "THIS_TAB";
})(FdrLinkOpenMethod || (FdrLinkOpenMethod = {}));
/** Link type. */
export var FdrLinkType;
(function (FdrLinkType) {
    /** Email link. */
    FdrLinkType["Email"] = "EMAIL";
    /** Link to external resource. */
    FdrLinkType["External"] = "EXTERNAL";
    /** Link to internal resource. */
    FdrLinkType["Internal"] = "INTERNAL";
})(FdrLinkType || (FdrLinkType = {}));
/** Notification show mode */
export var FdrMaintenanceNotificationShowMode;
(function (FdrMaintenanceNotificationShowMode) {
    FdrMaintenanceNotificationShowMode["Once"] = "ONCE";
    FdrMaintenanceNotificationShowMode["OnceEvery_2Hours"] = "ONCE_EVERY_2_HOURS";
    FdrMaintenanceNotificationShowMode["OnceEvery_24Hours"] = "ONCE_EVERY_24_HOURS";
})(FdrMaintenanceNotificationShowMode || (FdrMaintenanceNotificationShowMode = {}));
/** Maintenance notification type */
export var FdrMaintenanceNotificationType;
(function (FdrMaintenanceNotificationType) {
    FdrMaintenanceNotificationType["Emergency"] = "EMERGENCY";
    FdrMaintenanceNotificationType["Maintenance"] = "MAINTENANCE";
})(FdrMaintenanceNotificationType || (FdrMaintenanceNotificationType = {}));
/** Menu icon type */
export var FdrMenuIconType;
(function (FdrMenuIconType) {
    FdrMenuIconType["External"] = "EXTERNAL";
    FdrMenuIconType["Internal"] = "INTERNAL";
})(FdrMenuIconType || (FdrMenuIconType = {}));
export var FdrNewsletterStatus;
(function (FdrNewsletterStatus) {
    FdrNewsletterStatus["Error"] = "ERROR";
    FdrNewsletterStatus["Success"] = "SUCCESS";
})(FdrNewsletterStatus || (FdrNewsletterStatus = {}));
export var FdrNewsletterSubscriptionState;
(function (FdrNewsletterSubscriptionState) {
    FdrNewsletterSubscriptionState["Finalized"] = "FINALIZED";
    FdrNewsletterSubscriptionState["Pending"] = "PENDING";
})(FdrNewsletterSubscriptionState || (FdrNewsletterSubscriptionState = {}));
/** Type of newsletter. */
export var FdrNewsletterType;
(function (FdrNewsletterType) {
    FdrNewsletterType["DealOfTheWeek"] = "DEAL_OF_THE_WEEK";
    FdrNewsletterType["Hotelplan"] = "HOTELPLAN";
    FdrNewsletterType["MigrosFerien"] = "MIGROS_FERIEN";
    FdrNewsletterType["TourismePourTous"] = "TOURISME_POUR_TOUS";
    FdrNewsletterType["TourismePourTousHiking"] = "TOURISME_POUR_TOUS_HIKING";
    FdrNewsletterType["TourismePourTousSports"] = "TOURISME_POUR_TOUS_SPORTS";
    FdrNewsletterType["Travelhouse"] = "TRAVELHOUSE";
})(FdrNewsletterType || (FdrNewsletterType = {}));
export var FdrOfferSorting;
(function (FdrOfferSorting) {
    /** Sort product offers by departure airport alphabetically. */
    FdrOfferSorting["OfferDepartureAirport"] = "OFFER_DEPARTURE_AIRPORT";
    /** Sort product offers by departure date asc. */
    FdrOfferSorting["OfferDepartureDate"] = "OFFER_DEPARTURE_DATE";
    /** Sort product offers by length of stay asc. */
    FdrOfferSorting["OfferDuration"] = "OFFER_DURATION";
    /** Sort offers by price. */
    FdrOfferSorting["Price"] = "PRICE";
})(FdrOfferSorting || (FdrOfferSorting = {}));
export var FdrPkPassResponseStatus;
(function (FdrPkPassResponseStatus) {
    FdrPkPassResponseStatus["GeneratePasskitFileError"] = "GENERATE_PASSKIT_FILE_ERROR";
    FdrPkPassResponseStatus["NotModified"] = "NOT_MODIFIED";
    FdrPkPassResponseStatus["RetrieveTravelDataError"] = "RETRIEVE_TRAVEL_DATA_ERROR";
    FdrPkPassResponseStatus["Success"] = "SUCCESS";
    FdrPkPassResponseStatus["TravelDocumentNotFound"] = "TRAVEL_DOCUMENT_NOT_FOUND";
    FdrPkPassResponseStatus["WrongPassType"] = "WRONG_PASS_TYPE";
    FdrPkPassResponseStatus["WrongSerialNumber"] = "WRONG_SERIAL_NUMBER";
})(FdrPkPassResponseStatus || (FdrPkPassResponseStatus = {}));
/** Product offer group type enum. */
export var FdrProductOfferGroupType;
(function (FdrProductOfferGroupType) {
    /** Departure airport iata code group type. */
    FdrProductOfferGroupType["DepartureAirport"] = "DEPARTURE_AIRPORT";
    /** ISO departure date group type. */
    FdrProductOfferGroupType["DepartureDate"] = "DEPARTURE_DATE";
    /** Length of accommodation group type. */
    FdrProductOfferGroupType["Duration"] = "DURATION";
})(FdrProductOfferGroupType || (FdrProductOfferGroupType = {}));
/** Product offer status. */
export var FdrProductOfferStatus;
(function (FdrProductOfferStatus) {
    /** Offer is available and has no changes. */
    FdrProductOfferStatus["Available"] = "AVAILABLE";
    /** Offer is available and has flight details and price changes. */
    FdrProductOfferStatus["FlightAndPriceChanged"] = "FLIGHT_AND_PRICE_CHANGED";
    /** Offer is available and has flight details changed. */
    FdrProductOfferStatus["FlightChanged"] = "FLIGHT_CHANGED";
    /** Offer is not available anymore. */
    FdrProductOfferStatus["NotAvailable"] = "NOT_AVAILABLE";
    /** Offer is available and has price changes. */
    FdrProductOfferStatus["PriceChanged"] = "PRICE_CHANGED";
})(FdrProductOfferStatus || (FdrProductOfferStatus = {}));
export var FdrProductSorting;
(function (FdrProductSorting) {
    /** Sort by price. */
    FdrProductSorting["Price"] = "PRICE";
    /** Sort using bd4 recommendations. */
    FdrProductSorting["ProductBd4"] = "PRODUCT_BD4";
    /** Sort products by "top" product feature. */
    FdrProductSorting["ProductPopularity"] = "PRODUCT_POPULARITY";
    /** Sort products by Hotelplan rating. */
    FdrProductSorting["ProductRating"] = "PRODUCT_RATING";
    /** Sort products by trip advisor rating. */
    FdrProductSorting["ProductTaRating"] = "PRODUCT_TA_RATING";
})(FdrProductSorting || (FdrProductSorting = {}));
/** Product travel type. */
export var FdrProductTravelType;
(function (FdrProductTravelType) {
    /** Travel without flight included. */
    FdrProductTravelType["HotelOnly"] = "HOTEL_ONLY";
    /** Travel with departure and return flight included. */
    FdrProductTravelType["Package"] = "PACKAGE";
})(FdrProductTravelType || (FdrProductTravelType = {}));
/** Product type enum. */
export var FdrProductType;
(function (FdrProductType) {
    /** Adventure travel product. */
    FdrProductType["AdventureTravel"] = "ADVENTURE_TRAVEL";
    /** Cruise product. */
    FdrProductType["Cruise"] = "CRUISE";
    /** Hotel product. */
    FdrProductType["Hotel"] = "HOTEL";
    /** Round-trip product. */
    FdrProductType["Roundtrip"] = "ROUNDTRIP";
})(FdrProductType || (FdrProductType = {}));
/** Salutation */
export var FdrSalutation;
(function (FdrSalutation) {
    FdrSalutation["Mr"] = "MR";
    FdrSalutation["Ms"] = "MS";
})(FdrSalutation || (FdrSalutation = {}));
/** Type of user search */
export var FdrSearchHistoryType;
(function (FdrSearchHistoryType) {
    FdrSearchHistoryType["FlightSearch"] = "FLIGHT_SEARCH";
    FdrSearchHistoryType["HotelOnlySearch"] = "HOTEL_ONLY_SEARCH";
    FdrSearchHistoryType["PackageSearch"] = "PACKAGE_SEARCH";
    FdrSearchHistoryType["TextSearch"] = "TEXT_SEARCH";
})(FdrSearchHistoryType || (FdrSearchHistoryType = {}));
/** Search mode. */
export var FdrSearchMode;
(function (FdrSearchMode) {
    /** Search by word match */
    FdrSearchMode["FullWord"] = "FULL_WORD";
    /** Search by segments of the words */
    FdrSearchMode["PartialWord"] = "PARTIAL_WORD";
    /** Search by match of the sentence */
    FdrSearchMode["Phrase"] = "PHRASE";
})(FdrSearchMode || (FdrSearchMode = {}));
/** Types of objects that can be searched. */
export var FdrSearchType;
(function (FdrSearchType) {
    /** Adventure travels */
    FdrSearchType["Adventuretravel"] = "ADVENTURETRAVEL";
    /** Agency overview page */
    FdrSearchType["AgencyOverviewPage"] = "AGENCY_OVERVIEW_PAGE";
    /** Airport */
    FdrSearchType["Airport"] = "AIRPORT";
    /** Airport */
    FdrSearchType["AirportDeparture"] = "AIRPORT_DEPARTURE";
    /** Airport */
    FdrSearchType["AirportOneWay"] = "AIRPORT_ONE_WAY";
    /** Blog article */
    FdrSearchType["BlogArticle"] = "BLOG_ARTICLE";
    /** Catalogue page */
    FdrSearchType["CataloguePage"] = "CATALOGUE_PAGE";
    /** Continent */
    FdrSearchType["Continent"] = "CONTINENT";
    /** Country */
    FdrSearchType["Country"] = "COUNTRY";
    /** Countrygroup */
    FdrSearchType["Countrygroup"] = "COUNTRYGROUP";
    /** Cruise */
    FdrSearchType["Cruise"] = "CRUISE";
    /** Destination */
    FdrSearchType["Destination"] = "DESTINATION";
    /** Extra ordinary hotels */
    FdrSearchType["ExtraHotel"] = "EXTRA_HOTEL";
    /** Products found by GIATA code */
    FdrSearchType["Giata"] = "GIATA";
    /** Hotels */
    FdrSearchType["Hotel"] = "HOTEL";
    /** Airport found by IATA code */
    FdrSearchType["Iata"] = "IATA";
    /** Products found by MYTHOS code */
    FdrSearchType["Mythos"] = "MYTHOS";
    /** Newslette rregistration page */
    FdrSearchType["NewsletteRregistrationPage"] = "NEWSLETTE_RREGISTRATION_PAGE";
    /** Region */
    FdrSearchType["Region"] = "REGION";
    /** Resort */
    FdrSearchType["Resort"] = "RESORT";
    /** Roundtrips */
    FdrSearchType["Roundtrip"] = "ROUNDTRIP";
    /** Static page */
    FdrSearchType["StaticPage"] = "STATIC_PAGE";
    /** Theme */
    FdrSearchType["Theme"] = "THEME";
})(FdrSearchType || (FdrSearchType = {}));
export var FdrServiceStatus;
(function (FdrServiceStatus) {
    FdrServiceStatus["Available"] = "AVAILABLE";
    FdrServiceStatus["Confirmed"] = "CONFIRMED";
    FdrServiceStatus["Unknown"] = "UNKNOWN";
})(FdrServiceStatus || (FdrServiceStatus = {}));
/** Smart seer recommender search result status. */
export var FdrSmartSeerRecommenderStatus;
(function (FdrSmartSeerRecommenderStatus) {
    /** SmartSeer api timeout. */
    FdrSmartSeerRecommenderStatus["ApiTimeout"] = "API_TIMEOUT";
    /** Search result error. */
    FdrSmartSeerRecommenderStatus["Error"] = "ERROR";
    /** SmartSeer api not available. */
    FdrSmartSeerRecommenderStatus["NotAvailable"] = "NOT_AVAILABLE";
    /** Successfully found recommender offers. */
    FdrSmartSeerRecommenderStatus["Success"] = "SUCCESS";
    /** Too few offers from SmartSeer api. */
    FdrSmartSeerRecommenderStatus["TooFewResultsFromApi"] = "TOO_FEW_RESULTS_FROM_API";
    /** Too few offers from HUB. */
    FdrSmartSeerRecommenderStatus["TooFewResultsFromHub"] = "TOO_FEW_RESULTS_FROM_HUB";
})(FdrSmartSeerRecommenderStatus || (FdrSmartSeerRecommenderStatus = {}));
/** Sorting direction. */
export var FdrSortDirection;
(function (FdrSortDirection) {
    /** Sort by ascendant. */
    FdrSortDirection["Asc"] = "ASC";
    /** Sort by descendant. */
    FdrSortDirection["Desc"] = "DESC";
})(FdrSortDirection || (FdrSortDirection = {}));
/** Product search sorting type. */
export var FdrSorting;
(function (FdrSorting) {
    /** Sort geo objects tree alphabetically. Sorting applied separately to each geo children. */
    FdrSorting["GroupAlphabetic"] = "GROUP_ALPHABETIC";
    /** Sort geo objects tree by offer's flight duration. */
    FdrSorting["GroupFlightDuration"] = "GROUP_FLIGHT_DURATION";
    /** Sort geo objects tree by "top" geo feature. */
    FdrSorting["GroupTopDestination"] = "GROUP_TOP_DESTINATION";
    /** Sort product offers by departure airport alphabetically. */
    FdrSorting["OfferDepartureAirport"] = "OFFER_DEPARTURE_AIRPORT";
    /** Sort product offers by departure date asc. */
    FdrSorting["OfferDepartureDate"] = "OFFER_DEPARTURE_DATE";
    /** Sort product offers by length of stay asc. */
    FdrSorting["OfferDuration"] = "OFFER_DURATION";
    /** Sort by price. */
    FdrSorting["Price"] = "PRICE";
    /** Sort using bd4 recommendations. */
    FdrSorting["ProductBd4"] = "PRODUCT_BD4";
    /** Sort products by distance to point of interest. */
    FdrSorting["ProductDistanceToPoi"] = "PRODUCT_DISTANCE_TO_POI";
    /** Sort products by "top" product feature. */
    FdrSorting["ProductPopularity"] = "PRODUCT_POPULARITY";
    /** Sort products by Hotelplan rating. */
    FdrSorting["ProductRating"] = "PRODUCT_RATING";
    /** Sort products by trip advisor rating. */
    FdrSorting["ProductTaRating"] = "PRODUCT_TA_RATING";
})(FdrSorting || (FdrSorting = {}));
export var FdrTravelDocumentType;
(function (FdrTravelDocumentType) {
    FdrTravelDocumentType["CancelInvoice"] = "CANCEL_INVOICE";
    FdrTravelDocumentType["Document"] = "DOCUMENT";
    FdrTravelDocumentType["Invoice"] = "INVOICE";
})(FdrTravelDocumentType || (FdrTravelDocumentType = {}));
/** Travel period type. */
export var FdrTravelPeriodType;
(function (FdrTravelPeriodType) {
    FdrTravelPeriodType["Exact"] = "EXACT";
    FdrTravelPeriodType["Flexible"] = "FLEXIBLE";
})(FdrTravelPeriodType || (FdrTravelPeriodType = {}));
/** Object types available for visit history */
export var FdrVisitHistoryObjectType;
(function (FdrVisitHistoryObjectType) {
    FdrVisitHistoryObjectType["Agency"] = "AGENCY";
    FdrVisitHistoryObjectType["Geo"] = "GEO";
    FdrVisitHistoryObjectType["Product"] = "PRODUCT";
    FdrVisitHistoryObjectType["Static"] = "STATIC";
    FdrVisitHistoryObjectType["Theme"] = "THEME";
})(FdrVisitHistoryObjectType || (FdrVisitHistoryObjectType = {}));
/** Waiting screen type */
export var FdrWaitingScreenType;
(function (FdrWaitingScreenType) {
    FdrWaitingScreenType["Account"] = "ACCOUNT";
    FdrWaitingScreenType["Flight"] = "FLIGHT";
    FdrWaitingScreenType["Product"] = "PRODUCT";
})(FdrWaitingScreenType || (FdrWaitingScreenType = {}));
/** Weather icon scale enum. */
export var FdrWeatherForecastIconScale;
(function (FdrWeatherForecastIconScale) {
    /** Original scale, 50 x 50 px */
    FdrWeatherForecastIconScale["X1"] = "X1";
    /** 100 x 100 px */
    FdrWeatherForecastIconScale["X2"] = "X2";
    /** 200 x 200 px */
    FdrWeatherForecastIconScale["X4"] = "X4";
})(FdrWeatherForecastIconScale || (FdrWeatherForecastIconScale = {}));
/** Weekdays enum. */
export var FdrWeekday;
(function (FdrWeekday) {
    FdrWeekday["Friday"] = "FRIDAY";
    FdrWeekday["Monday"] = "MONDAY";
    FdrWeekday["Saturday"] = "SATURDAY";
    FdrWeekday["Sunday"] = "SUNDAY";
    FdrWeekday["Thursday"] = "THURSDAY";
    FdrWeekday["Tuesday"] = "TUESDAY";
    FdrWeekday["Wednesday"] = "WEDNESDAY";
})(FdrWeekday || (FdrWeekday = {}));
/** Bookmark types have to be divided by product types as well */
export var FrdBookmarkItemType;
(function (FrdBookmarkItemType) {
    FrdBookmarkItemType["Geo"] = "GEO";
    FrdBookmarkItemType["ProductA"] = "PRODUCT_A";
    FrdBookmarkItemType["ProductH"] = "PRODUCT_H";
    FrdBookmarkItemType["ProductO"] = "PRODUCT_O";
    FrdBookmarkItemType["ProductS"] = "PRODUCT_S";
    FrdBookmarkItemType["Theme"] = "THEME";
})(FrdBookmarkItemType || (FrdBookmarkItemType = {}));
export var FrdBookmarkType;
(function (FrdBookmarkType) {
    FrdBookmarkType["AdventureTravel"] = "ADVENTURE_TRAVEL";
    FrdBookmarkType["Cruise"] = "CRUISE";
    FrdBookmarkType["Geo"] = "GEO";
    FrdBookmarkType["Hotel"] = "HOTEL";
    FrdBookmarkType["RoundTrip"] = "ROUND_TRIP";
    FrdBookmarkType["Theme"] = "THEME";
})(FrdBookmarkType || (FrdBookmarkType = {}));
/** Graph metadata. */
export var FdrGraphMeta;
(function (FdrGraphMeta) {
    /**
     * SUBGRAPH_COMMIT_HASH=4f530bc9e03c1d54fe868a75829aeea799b80a41
     *
     * SUBGRAPH_COMMIT_AUTHOR=Max Byshnev
     *
     * SUBGRAPH_COMMIT_DATE=Mon Jun 30 15:10:52 2025 +0300
     */
    FdrGraphMeta["Accountsubgraph"] = "accountsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=027f09d83aad31dfd12923ada5605ad7d3cbf483
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Dudin
     *
     * SUBGRAPH_COMMIT_DATE=Wed Jun 18 14:11:14 2025 +0300
     */
    FdrGraphMeta["Agencysubgraph"] = "agencysubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=328d8f5f84a409c0ce4932a8e97e17dd38c8e9c0
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:43 2025 +0300
     */
    FdrGraphMeta["Blogsubgraph"] = "blogsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=ef7b039ee7c03f7e8ea9fc1464c44dd691a2f183
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:38 2025 +0300
     */
    FdrGraphMeta["Catalogsubgraph"] = "catalogsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=5ac1739412c549dde8c3cee493b11deb4898160b
     *
     * SUBGRAPH_COMMIT_AUTHOR=Sergey_Zhulenev
     *
     * SUBGRAPH_COMMIT_DATE=Mon Jun 30 16:52:47 2025 +0300
     */
    FdrGraphMeta["Cmssubgraph"] = "cmssubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=c4876dab41fba37236893beff46614e727d1579b
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:36 2025 +0300
     */
    FdrGraphMeta["Emailadvertisingsubgraph"] = "emailadvertisingsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=56d4d80551c88be0dbf42a76f903a70d9f331359
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Dudin
     *
     * SUBGRAPH_COMMIT_DATE=Thu Jun 19 11:39:18 2025 +0300
     */
    FdrGraphMeta["Extensionsubgraph"] = "extensionsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=a3e5fa0b1052ff154d620171507db5180670aae9
     *
     * SUBGRAPH_COMMIT_AUTHOR=Victor Sannikov
     *
     * SUBGRAPH_COMMIT_DATE=Fri Jun 27 13:02:30 2025 +0300
     */
    FdrGraphMeta["Historysubgraph"] = "historysubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=38457b5162752562c16793d1f253886dac374654
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:41 2025 +0300
     */
    FdrGraphMeta["Reviewsubgraph"] = "reviewsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=60e81969826aebf7c155d7c7bc5e3be2dcf00d70
     *
     * SUBGRAPH_COMMIT_AUTHOR=Max Byshnev
     *
     * SUBGRAPH_COMMIT_DATE=Tue Jun 17 15:33:44 2025 +0300
     */
    FdrGraphMeta["Searchsubgraph"] = "searchsubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=759af27452473eb8c91f5e95795b76349650b42f
     *
     * SUBGRAPH_COMMIT_AUTHOR=Max Byshnev
     *
     * SUBGRAPH_COMMIT_DATE=Thu Mar 20 19:07:39 2025 +0300
     */
    FdrGraphMeta["Smartseersubgraph"] = "smartseersubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=185ee7f75f2df120dc86ea62b5ecf3fc7d3d16fc
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:39 2025 +0300
     */
    FdrGraphMeta["Weathersubgraph"] = "weathersubgraph";
    /**
     * SUBGRAPH_COMMIT_HASH=dd592cdf1fee964db183b7caceb4819b07ac9545
     *
     * SUBGRAPH_COMMIT_AUTHOR=Alexander Starovoitov
     *
     * SUBGRAPH_COMMIT_DATE=Thu Feb 27 19:00:38 2025 +0300
     */
    FdrGraphMeta["Wishlistsubgraph"] = "wishlistsubgraph";
})(FdrGraphMeta || (FdrGraphMeta = {}));
